import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const GrabHandle = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path d="M5 8H15M5 12H15" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    )
  },
)

export default GrabHandle
